import {
  Avatar,
  Box,
  Stack,
  Typography,
  Button,
  Drawer,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Grid from "@mui/material/Grid2";
import NoProfile from "../../assets/images/No_Profile.svg";
import Styles from "./EmployeeDetails.module.scss";
import DownloadPayslipButton from "../../components/Employee/DownloadPayslipButton";

import Blood_Icon from "../../assets/images/EmployeeDetails/Blood.svg";
import Phone_Icon from "../../assets/images/EmployeeDetails/Phone.svg";
import Email_Icon from "../../assets/images/EmployeeDetails/Email.svg";
import Person_Icon from "../../assets/images/EmployeeDetails/Person.svg";
import Relation_Icon from "../../assets/images/EmployeeDetails/Relation.svg";
import Address_Icon from "../../assets/images/EmployeeDetails/Address.svg";
import Place_Icon from "../../assets/images/EmployeeDetails/Place.svg";
import EditProfile_Icon from "../../assets/images/EmployeeDetails/EditProfile.svg";
import ChangePassword_Icon from "../../assets/images/EmployeeDetails/ChangePassword.svg";

import {
  Chip,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from "@mui/material";
import {
  EventBusy,
  CheckCircle,
  Cancel,
  HourglassEmpty,
  DateRange,
  Description,
  CalendarMonth,
  Badge,
  CreditCard,
  School,
  Article,
  AttachFile,
  FolderOpen
} from "@mui/icons-material";

import { getUserById } from "../../services/user.service";
import CommonLoader from "../../common/CommonLoader/CommonLoader";
import { jwtDecode } from "jwt-decode";
import { useAuth } from "../../context/AuthProvider";
import ChangePassword from "../User/ChangePassword";
import { getDocumentsByEmployeeId } from "../../services/employeeDocument.service";
import { getPayrollByEmployeeId } from "../../services/payroll.service";
import { getLeaveByUserId } from "../../services/leaveManagement.service";
import { getAttendance } from "../../services/reports.service";

import { encrypt, decrypt } from "../../utils/crypto";
import dayjs from "dayjs";
import { isAdminRole } from "../../utils/roles";

const EmployeeDetails = (props) => {
  const location = useLocation();
  const { accessToken } = useAuth();
  const queryParams = new URLSearchParams(location.search);
  const [selectedData, setSelectedData] = useState({});
  const navigate = useNavigate();
  const [who, setIsWho] = useState(false);
  const [isOwnProfile, setIsOwnProfile] = useState(false);

  const id = queryParams.get("id");
  const [openLoader, setOpenLoader] = useState(true);
  const [activeTab, setActiveTab] = useState("Overview");
  const [openChangePasswordDrawer, setOpenChangePasswordDrawer] = useState(false);

  // Tab Data States
  const [documents, setDocuments] = useState([]);
  const [payroll, setPayroll] = useState([]);
  const [leaveHistory, setLeaveHistory] = useState([]);
  const [attendance, setAttendance] = useState([]);
  const [leaveFilter, setLeaveFilter] = useState("All");

  const GetSeparateUserId = async (id) => {
    try {
      const res = await getUserById(id);
      const configData = res?.data?.data;
      setSelectedData(configData);
      setOpenLoader(false);
    } catch (error) {
      console.log(error);
      setOpenLoader(false);
    }
  };

  useEffect(() => {
    if (id) {
      GetSeparateUserId(id);
    } else {
      const seleData = location?.state?.selectedData;
      if (seleData) {
        setSelectedData(seleData);
        setOpenLoader(false);
      }
    }
  }, [id, location.state]);

  useEffect(() => {
    if (accessToken) {
      try {
        const decodedToken = jwtDecode(accessToken);
        setIsWho(isAdminRole(decodedToken.role));
        if (selectedData?._id) {
          setIsOwnProfile(decodedToken.id === selectedData._id || decodedToken._id === selectedData._id);
        }
      } catch (error) {
        console.error("Error decoding token:", error);
      }
    }
  }, [accessToken, selectedData]);

  // Fetch data based on active tab
  useEffect(() => {
    const fetchData = async () => {
      if (!selectedData._id) return;

      try {
        if (activeTab === "Documents") {
          const res = await getDocumentsByEmployeeId(selectedData._id);
          setDocuments(res.data?.data || []);
        } else if (activeTab === "Payroll") {
          const res = await getPayrollByEmployeeId(selectedData._id);
          setPayroll(res.data?.data || []);
        } else if (activeTab === "Leave History") {
          const res = await getLeaveByUserId(selectedData._id);
          setLeaveHistory(res.data?.data || []);
        } else if (activeTab === "Attendance") {
          const dateRange = [dayjs().startOf('month'), dayjs().endOf('month')];
          const formData = {
            userId: selectedData._id,
            date: dateRange,
          };
          const encryptData = encrypt(formData);
          const res = await getAttendance({ encryptData });
          if (res.data?.result) {
            const decryptedData = decrypt(res.data.result);
            setAttendance(decryptedData || []);
          }
        }
      } catch (error) {
        console.error(`Error fetching ${activeTab} data:`, error);
      }
    };

    fetchData();
  }, [activeTab, selectedData._id]);

  const renderFile = (file) => {
    if (!file?.location) return <img src={NoProfile} alt="No_Profile" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />;
    return (
      <img
        src={file.location}
        alt={file.fileName || "No Profile"}
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
        }}
      />
    );
  };

  const handleEdit = () => {
    navigate(`/home/editEmployee?id=${selectedData._id}`, {
      state: { selectedData: selectedData, formType: "edit" },
    });
  };

  const handleChangePassword = () => {
    setOpenChangePasswordDrawer(true);
  };

  //JoiningDate
  const joiningDate = selectedData?.joiningDate;
  const joiningDateObject = new Date(joiningDate);
  const formattedDateJoiningDate = !isNaN(joiningDateObject) ? joiningDateObject.toLocaleDateString(
    "en-GB",
    {
      day: "2-digit",
      month: "long",
      year: "numeric",
    }
  ) : "-";

  //DateOfBirth
  const dateOfBirth = selectedData?.dateOfBirth;
  const dateOfBirthObject = new Date(dateOfBirth);
  const formattedDateDateOfBirth = !isNaN(dateOfBirthObject) ?
    dateOfBirthObject.toLocaleDateString("en-GB") : "-";

  const project_names =
    selectedData?.project?.map((project) => project.shortName) || [];
  const formatted_project_names = project_names.join(", ").replace(/\s+/g, " ");

  if (openLoader) {
    return <CommonLoader />;
  }

  const InfoRow = ({ icon, label, value }) => (
    <div className={Styles.infoRow}>
      <div className={Styles.iconWrapper}>
        <img src={icon} alt={label} />
      </div>
      <span className={Styles.label}>{label}</span>
      <span className={Styles.value}>{value || " - "}</span>
    </div>
  );

  const DetailItem = ({ label, value }) => (
    <div className={Styles.detailItem}>
      <div className={Styles.detailLabel}>{label}</div>
      <div className={Styles.detailValue}>{value || " - "}</div>
    </div>
  );

  const renderContent = () => {
    switch (activeTab) {
      case "Overview":
        return (
          <>
            <div className={Styles.sectionHeader}>Professional Details</div>
            <div className={Styles.detailGrid}>
              <DetailItem label="Department" value={selectedData?.departmentName} />
              <DetailItem label="Employee Type" value={selectedData?.employeeDetails?.employeeType} />
              <DetailItem label="Employee Status" value={selectedData?.employeeDetails?.employeeStatus} />
              <DetailItem label="Joining Date" value={formattedDateJoiningDate} />
              <DetailItem label="Member ID" value={selectedData?.employeeDetails?.memberID} />
              <DetailItem label="PF Number" value={selectedData?.employeeDetails?.pfNumber} />
              <DetailItem label="Project" value={formatted_project_names} />
            </div>

            <Box mt={4} mb={4}><hr style={{ border: '0', borderTop: '1px solid #f1f5f9' }} /></Box>

            <div className={Styles.sectionHeader}>Personal Details</div>
            <div className={Styles.detailGrid}>
              <DetailItem label="Gender" value={selectedData?.gender} />
              <DetailItem label="Date of Birth" value={formattedDateDateOfBirth} />
              <DetailItem label="Marital Status" value={selectedData?.maritalStatus} />
              <DetailItem label="Aadhaar Number" value={selectedData?.aadhaarNumber} />
              <DetailItem label="PAN Number" value={selectedData?.panNumber} />
            </div>

            <Box mt={4} mb={4}><hr style={{ border: '0', borderTop: '1px solid #f1f5f9' }} /></Box>

            <div className={Styles.sectionHeader}>Address Details</div>
            <Grid container spacing={3}>
              <Grid size={{ xs: 12, md: 6 }}>
                <div className={Styles.detailItem}>
                  <div className={Styles.detailLabel}>Current Address</div>
                  <div className={Styles.detailValue}>
                    {selectedData?.address?.currentAddress?.doorNo_street || selectedData?.address?.currentAddress?.place ? (
                      <>
                        {selectedData?.address?.currentAddress?.doorNo_street}
                        {selectedData?.address?.currentAddress?.doorNo_street && selectedData?.address?.currentAddress?.place ? ", " : ""}
                        {selectedData?.address?.currentAddress?.place}
                        <br />
                        {selectedData?.address?.currentAddress?.district}
                        {selectedData?.address?.currentAddress?.district && selectedData?.address?.currentAddress?.pincode ? " - " : ""}
                        {selectedData?.address?.currentAddress?.pincode}
                      </>
                    ) : " - "}
                  </div>
                </div>
              </Grid>
              <Grid size={{ xs: 12, md: 6 }}>
                <div className={Styles.detailItem}>
                  <div className={Styles.detailLabel}>Permanent Address</div>
                  <div className={Styles.detailValue}>
                    {selectedData?.address?.permanentAddress?.doorNo_street || selectedData?.address?.permanentAddress?.place ? (
                      <>
                        {selectedData?.address?.permanentAddress?.doorNo_street}
                        {selectedData?.address?.permanentAddress?.doorNo_street && selectedData?.address?.permanentAddress?.place ? ", " : ""}
                        {selectedData?.address?.permanentAddress?.place}
                        <br />
                        {selectedData?.address?.permanentAddress?.district}
                        {selectedData?.address?.permanentAddress?.district && selectedData?.address?.permanentAddress?.pincode ? " - " : ""}
                        {selectedData?.address?.permanentAddress?.pincode}
                      </>
                    ) : " - "}
                  </div>
                </div>
              </Grid>
            </Grid>
          </>
        );
      case "Documents":
        const employeeDocuments = [
          { label: "Aadhaar Card", data: selectedData?.aadhaarCard, icon: Badge, color: "#3b82f6" },
          { label: "PAN Card", data: selectedData?.panCard, icon: CreditCard, color: "#8b5cf6" },
          { label: "10th Mark Sheet", data: selectedData?.tenthMarkSheet, icon: School, color: "#10b981" },
          { label: "12th Mark Sheet", data: selectedData?.twelfthMarkSheet, icon: Article, color: "#f59e0b" },
          { label: "Resume", data: selectedData?.resume, icon: Article, color: "#f59e0b" },
        ].filter(doc => doc.data && doc.data.location);

        return (
          <>
            <div className={Styles.sectionHeader}>Employee Documents</div>
            {employeeDocuments.length > 0 ? (
              <Grid container spacing={3} sx={{ mb: 4 }}>
                {employeeDocuments.map((doc, index) => (
                  <Grid size={{ xs: 12, sm: 6, md: 3 }} key={index}>
                    <Paper
                      elevation={0}
                      sx={{
                        p: 3,
                        border: '1px solid #f1f5f9',
                        borderRadius: 3,
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                        cursor: 'pointer',
                        '&:hover': {
                          transform: 'translateY(-4px)',
                          boxShadow: '0 12px 24px -10px rgba(0,0,0,0.1)',
                          borderColor: doc.color,
                        }
                      }}
                    >
                      <Box
                        sx={{
                          width: 56,
                          height: 56,
                          borderRadius: 2,
                          background: `linear-gradient(135deg, ${doc.color}15 0%, ${doc.color}05 100%)`,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          mb: 2
                        }}
                      >
                        <doc.icon sx={{ fontSize: 32, color: doc.color }} />
                      </Box>
                      <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 0.5, color: '#1e293b' }}>
                        {doc.label}
                      </Typography>
                      {/* <Typography variant="caption" sx={{ color: '#64748b', mb: 2, flexGrow: 1 }}>
                        {doc.data.fileName || 'Document file'}
                      </Typography> */}
                      <Button
                        href={doc.data.location}
                        target="_blank"
                        rel="noopener noreferrer"
                        fullWidth
                        variant="outlined"
                        size="small"
                        sx={{
                          borderColor: doc.color,
                          color: doc.color,
                          textTransform: 'none',
                          fontWeight: 500,
                          '&:hover': {
                            borderColor: doc.color,
                            backgroundColor: `${doc.color}10`,
                          }
                        }}
                      >
                        View Document
                      </Button>
                    </Paper>
                  </Grid>
                ))}
              </Grid>
            ) : (
              <Box sx={{
                textAlign: 'center',
                py: 8,
                mb: 4,
                backgroundColor: '#fafafa',
                borderRadius: 3,
                border: '2px dashed #e0e0e0'
              }}>
                <FolderOpen sx={{ fontSize: 64, color: '#cbd5e1', mb: 2 }} />
                <Typography variant="h6" sx={{ color: '#64748b', fontWeight: 500 }}>
                  No employee documents uploaded
                </Typography>
                <Typography variant="body2" sx={{ color: '#94a3b8', mt: 1 }}>
                  Documents will appear here once uploaded
                </Typography>
              </Box>
            )}

            {documents.length > 0 && (
              <>
                <div className={Styles.sectionHeader}>Other Documents</div>
                <Stack spacing={2}>
                  {documents.map((doc) => (
                    <Paper
                      key={doc._id}
                      elevation={0}
                      sx={{
                        p: 2.5,
                        border: '1px solid #f1f5f9',
                        borderRadius: 2,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        transition: 'all 0.2s',
                        '&:hover': {
                          borderColor: '#e2e8f0',
                          backgroundColor: '#fafafa',
                        }
                      }}
                    >
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flex: 1 }}>
                        <Box
                          sx={{
                            width: 48,
                            height: 48,
                            borderRadius: 2,
                            background: 'linear-gradient(135deg, #008080 0%, #006666 100%)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            flexShrink: 0
                          }}
                        >
                          <AttachFile sx={{ fontSize: 24, color: 'white' }} />
                        </Box>
                        <Box sx={{ minWidth: 0, flex: 1 }}>
                          <Typography variant="subtitle2" sx={{ fontWeight: 600, color: '#1e293b', mb: 0.5 }}>
                            {doc.fileName}
                          </Typography>
                          <Typography variant="caption" sx={{ color: '#64748b', display: 'block' }}>
                            {doc.description || 'No description provided'} • Uploaded on {new Date(doc.createdAt).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
                          </Typography>
                        </Box>
                      </Box>
                      <Button
                        href={doc.fileUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        variant="contained"
                        size="small"
                        sx={{
                          backgroundColor: '#008080',
                          textTransform: 'none',
                          fontWeight: 500,
                          minWidth: 100,
                          '&:hover': {
                            backgroundColor: '#006666',
                          }
                        }}
                      >
                        View
                      </Button>
                    </Paper>
                  ))}
                </Stack>
              </>
            )}
          </>
        );
      case "Attendance":
        return (
          <>
            <div className={Styles.sectionHeader}>Attendance History</div>
            {attendance.length > 0 ? (
              <TableContainer component={Paper} sx={{ boxShadow: 'none', border: '1px solid #e0e0e0' }}>
                <Table>
                  <TableHead sx={{ backgroundColor: '#f5f5f5' }}>
                    <TableRow>
                      <TableCell>Date</TableCell>
                      <TableCell>Check In</TableCell>
                      <TableCell>Check Out</TableCell>
                      <TableCell>Total Hours</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {attendance.map((att) => (
                      <TableRow key={att._id}>
                        <TableCell>{new Date(att.date).toLocaleDateString()}</TableCell>
                        <TableCell>{att.checkInTime ? new Date(att.checkInTime).toLocaleTimeString() : '-'}</TableCell>
                        <TableCell>{att.checkOutTime ? new Date(att.checkOutTime).toLocaleTimeString() : '-'}</TableCell>
                        <TableCell>{att.totalHours || '-'}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            ) : (
              <Typography color="textSecondary">No attendance records found.</Typography>
            )}
          </>
        );
      case "Leave History":
        const filteredLeaveHistory = leaveHistory.filter(leave => {
          if (leaveFilter === "All") return true;
          return leave.status === leaveFilter;
        });

        const stats = {
          total: leaveHistory.length,
          approved: leaveHistory.filter(l => l.status === 'Approved').length,
          rejected: leaveHistory.filter(l => l.status === 'Rejected').length,
          pending: leaveHistory.filter(l => l.status === 'Pending').length
        };

        return (
          <>
            <div className={Styles.sectionHeader}>Leave History</div>

            {/* Stats Row */}
            <div className={Styles.statsContainer}>
              <div className={Styles.statCard}>
                <div className={Styles.statIcon} style={{ background: '#e0f2fe', color: '#0284c7' }}>
                  <CalendarMonth />
                </div>
                <div className={Styles.statInfo}>
                  <span className={Styles.statValue}>{stats.total}</span>
                  <span className={Styles.statLabel}>Total Leaves</span>
                </div>
              </div>
              <div className={Styles.statCard}>
                <div className={Styles.statIcon} style={{ background: '#dcfce7', color: '#16a34a' }}>
                  <CheckCircle />
                </div>
                <div className={Styles.statInfo}>
                  <span className={Styles.statValue}>{stats.approved}</span>
                  <span className={Styles.statLabel}>Approved</span>
                </div>
              </div>
              <div className={Styles.statCard}>
                <div className={Styles.statIcon} style={{ background: '#ffedd5', color: '#ea580c' }}>
                  <HourglassEmpty />
                </div>
                <div className={Styles.statInfo}>
                  <span className={Styles.statValue}>{stats.pending}</span>
                  <span className={Styles.statLabel}>Pending</span>
                </div>
              </div>
              <div className={Styles.statCard}>
                <div className={Styles.statIcon} style={{ background: '#fee2e2', color: '#dc2626' }}>
                  <Cancel />
                </div>
                <div className={Styles.statInfo}>
                  <span className={Styles.statValue}>{stats.rejected}</span>
                  <span className={Styles.statLabel}>Rejected</span>
                </div>
              </div>
            </div>

            {/* Filters */}
            <div className={Styles.leaveFilters}>
              <Typography variant="h6" sx={{ fontSize: '16px', fontWeight: 600, color: '#475569' }}>
                Recent Requests
              </Typography>
              <FormControl size="small" sx={{ minWidth: 150 }}>
                <InputLabel>Status</InputLabel>
                <Select
                  value={leaveFilter}
                  label="Status"
                  onChange={(e) => setLeaveFilter(e.target.value)}
                >
                  <MenuItem value="All">All Status</MenuItem>
                  <MenuItem value="Approved">Approved</MenuItem>
                  <MenuItem value="Pending">Pending</MenuItem>
                  <MenuItem value="Rejected">Rejected</MenuItem>
                </Select>
              </FormControl>
            </div>

            {/* Leave List */}
            <div className={Styles.leaveList}>
              {filteredLeaveHistory.length > 0 ? (
                filteredLeaveHistory.map((leave) => (
                  <div key={leave._id} className={Styles.leaveCard}>
                    <div className={Styles.leaveLeft}>
                      <div className={Styles.dateBox}>
                        <div className={Styles.month}>
                          {new Date(leave.startDate).toLocaleString('default', { month: 'short' })}
                        </div>
                        <div className={Styles.day}>
                          {new Date(leave.startDate).getDate()}
                        </div>
                      </div>
                      <div className={Styles.leaveDetails}>
                        <div className={Styles.leaveType}>{leave.leaveType}</div>
                        <div className={Styles.leaveReason}>{leave.reason}</div>
                        <div className={Styles.leaveDuration}>
                          <DateRange sx={{ fontSize: 14 }} />
                          {new Date(leave.startDate).toLocaleDateString()} - {new Date(leave.endDate).toLocaleDateString()}
                        </div>
                      </div>
                    </div>
                    <div className={Styles.leaveRight}>
                      <Chip
                        label={leave.status}
                        size="small"
                        sx={{
                          backgroundColor: leave.status === 'Approved' ? '#dcfce7' : leave.status === 'Rejected' ? '#fee2e2' : '#ffedd5',
                          color: leave.status === 'Approved' ? '#16a34a' : leave.status === 'Rejected' ? '#dc2626' : '#ea580c',
                          fontWeight: 600
                        }}
                      />
                    </div>
                  </div>
                ))
              ) : (
                <div style={{ textAlign: 'center', padding: '40px', color: '#94a3b8' }}>
                  <EventBusy sx={{ fontSize: 48, marginBottom: 1, opacity: 0.5 }} />
                  <Typography>No leave records found</Typography>
                </div>
              )}
            </div>
          </>
        );
      case "Payroll":
        return (
          <>
            <div className={Styles.sectionHeader}>Payroll</div>
            {payroll.length > 0 ? (
              <TableContainer component={Paper} sx={{ boxShadow: 'none', border: '1px solid #e0e0e0' }}>
                <Table>
                  <TableHead sx={{ backgroundColor: '#f5f5f5' }}>
                    <TableRow>
                      <TableCell>Month/Year</TableCell>
                      <TableCell>Basic Salary</TableCell>
                      <TableCell>Allowances</TableCell>
                      <TableCell>Deductions</TableCell>
                      <TableCell>Net Salary</TableCell>
                      <TableCell>Status</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {payroll.map((pay) => (
                      <TableRow key={pay._id}>
                        <TableCell>{pay.month}/{pay.year}</TableCell>
                        <TableCell>{pay.basicSalary}</TableCell>
                        <TableCell>{pay.allowances}</TableCell>
                        <TableCell>{pay.deductions}</TableCell>
                        <TableCell sx={{ fontWeight: 600 }}>{pay.netSalary}</TableCell>
                        <TableCell>{pay.status}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            ) : (
              <Typography color="textSecondary">No payroll records found.</Typography>
            )}
          </>
        );
      default:
        return null;
    }
  };

  return (
    <div className={Styles.pageContainer}>
      {/* Top Card Section */}
      <div className={Styles.topCard}>
        <Grid container spacing={4} alignItems="center">
          <Grid size={{ xs: 12, md: 4 }}>
            <div className={Styles.avatarContainer}>
              <Avatar className={Styles.avatar}>
                {renderFile(selectedData?.file)}
              </Avatar>
              <div className={Styles.nameSection}>
                <span className={Styles.name}>{selectedData?.name}</span>
                <span className={Styles.role}>{selectedData?.employeeDetails?.employeeRole}</span>
                <span className={Styles.id}>{selectedData?.employeeID}</span>
              </div>
            </div>
          </Grid>

          <Grid size={{ xs: 12, md: 4 }}>
            <div className={Styles.infoSection}>
              <div className={Styles.sectionTitle}>Contact Info</div>
              <InfoRow icon={Blood_Icon} label="Blood Group" value={selectedData?.bloodGroup} />
              <InfoRow icon={Phone_Icon} label="Phone" value={selectedData?.mobileNo} />
              <InfoRow icon={Email_Icon} label="Email" value={selectedData?.email} />
            </div>
          </Grid>

          <Grid size={{ xs: 12, md: 4 }}>
            <div className={Styles.infoSection}>
              <div className={Styles.sectionTitle}>Emergency Contact</div>
              <InfoRow icon={Person_Icon} label="Name" value={selectedData?.emergencyDetails?.name} />
              <InfoRow icon={Relation_Icon} label="Relation" value={selectedData?.emergencyDetails?.relation} />
              <InfoRow icon={Phone_Icon} label="Phone" value={selectedData?.emergencyDetails?.mobileNo} />
            </div>
            {(who || isOwnProfile) && (
              <div className={Styles.actionButtons} >
                <DownloadPayslipButton
                  employeeData={selectedData}
                  style={{ marginRight: '10px' }}
                />
                <Button
                  className={`${Styles.actionBtn} ${Styles.editBtn}`}
                  onClick={handleEdit}
                  size="small"
                  sx={{ fontSize: '0.8rem', minWidth: 'auto', px: 2, whiteSpace: 'nowrap' }}
                >
                  <img src={EditProfile_Icon} alt="Edit" width={14} style={{ marginRight: 4 }} /> Edit Profile
                </Button>
                <Button
                  className={`${Styles.actionBtn} ${Styles.passwordBtn}`}
                  onClick={handleChangePassword}
                  size="small"
                  sx={{ fontSize: '0.8rem', minWidth: 'auto', px: 2, whiteSpace: 'nowrap' }}
                >
                  <img src={ChangePassword_Icon} alt="Password" width={14} style={{ marginRight: 4 }} /> Change Password
                </Button>
              </div>
            )}
          </Grid>
        </Grid>
      </div>

      {/* Main Content Section */}
      <div className={Styles.detailsContainer}>
        {/* Sidebar Menu */}
        <div className={Styles.sidebarMenu}>
          <div className={Styles.menuTitle}>Profile Sections</div>
          {["Overview", "Documents", "Leave History"].map((item) => (
            <div
              key={item}
              className={`${Styles.menuItem} ${activeTab === item ? Styles.menuItemActive : ""}`}
              onClick={() => setActiveTab(item)}
            >
              {item}
            </div>
          ))}
        </div>

        {/* Content Area */}
        <div className={Styles.contentArea}>
          {renderContent()}
        </div>
      </div>

      <Drawer
        anchor="right"
        open={openChangePasswordDrawer}
        onClose={() => setOpenChangePasswordDrawer(false)}
      >
        <ChangePassword
          setOpenDrawer={setOpenChangePasswordDrawer}
          formType="edit"
          selectedData={selectedData}
        />
      </Drawer>
    </div>
  );
};

export default EmployeeDetails;
